import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'src/app/features/onboarding/login/login.component';
import { RegistrationComponent } from 'src/app/features/onboarding/registration/registration.component';
import { ResetPasswordComponent } from 'src/app/features/onboarding/reset-password/reset-password.component';
import { VerificationComponent } from 'src/app/features/onboarding/verification/verification.component';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';
import { RouterOutletComponent } from './components/router-outlet/router-outlet.component';
import { ImvideoComponent } from './i-am-video/components/imvideo/imvideo.component';
import { SetupPasswordComponent } from 'src/app/features/onboarding/reset-password/setup-password/setup-password.component';
import { TreasuryComponent } from 'src/app/features/onboarding/treasury/treasury.component';
import { Setup1Component } from 'src/app/features/onboarding/setup/setup1/setup1.component';
import { Setup2Component } from 'src/app/features/onboarding/setup/setup2/setup2.component';
import { Setup3Component } from 'src/app/features/onboarding/setup/setup3/setup3.component';
import { Setup4Component } from 'src/app/features/onboarding/setup/setup4/setup4.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { CreaticsAboutComponent } from './components/creatics-about/creatics-about.component';
import { LoggedInHomepageComponent } from './components/logged-in-homepage/logged-in-homepage.component';
import { AuthResolveGuard } from 'src/app/features/onboarding/auth-resolve.guard';
import { VerificationURLComponent } from '../onboarding/verification-url/verification-url.component';
import { SignUpVerificationURLComponent } from '../onboarding/signup-email-verification/signup-email-verification.component';
import { MyInboxComponent } from '../onboarding/my-inbox/my-inbox.component';
import { TeamComponent } from './team/team.component';
import { BadgesAwardsComponent } from './badges-awards/badges-awards.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { CreateYourDreamsComponent } from './create-your-dreams/create-your-dreams.component';
import { MeetTheCreaticsComponent } from './meet-the-creatics/meet-the-creatics.component';
import { PricingAndAccessComponent } from './pricing-and-access/pricing-and-access.component';
import { PricingAccessPaymentReceiptComponent } from './pricing-and-access/pricing-access-payment-receipt/pricing-access-payment-receipt.component';
import { NotificationsComponent } from './my-account/components/notifications/notifications.component';
import { TermsComponent } from 'src/app/shared/creatics/common/terms&conditions/terms.component';
import { PrivacyComponent } from 'src/app/shared/creatics/common/privacy-policy/privacy.component';
import { PrizesAndPerksComponent } from './prizes-and-perks/prizes-and-perks.component';

const routes: Routes = [

  {
    path: '',
    component: RouterOutletComponent,
    children: [
      {
        path: '',
        component: HomepageComponent

      },
      {
        path: 'userProfiles/home/:id',
        component: LoggedInHomepageComponent,
      },
      {
        path: 'about',
        component: CreaticsAboutComponent,
      },
      {
        path: 'picture-the-possibilities',
        loadChildren: () => import('../creatics/picture-the-possibilities/picture-the-possibilities.module').then(m => m.PictureThePossibilitiesModule),
      },
      {
        path: 'hitmaker',
        loadChildren: () => import('../creatics/hitmaker/hitmaker.module').then(m => m.HitmakerModule),
      },
      {
        path: 'contest',
        loadChildren: () => import('../creatics/contest and drawings/contestanddrawing.module').then(m => m.ContestanddrawingModule),
      },
      {
        path: 'userProfiles/:id/create/i-am-video',
        component:ImvideoComponent
      },

      {
        path: 'login',
        component: LoginComponent,
        canActivate: [AuthResolveGuard]
      },
      {
        path: 'signup',
        component: RegistrationComponent,
        canActivate: [AuthResolveGuard]
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [AuthResolveGuard]
      },
      {
        path: 'verification',
        component: VerificationComponent,
        canActivate: [AuthResolveGuard]
      },
      {
        path: 'setup-password',
        component: SetupPasswordComponent,
        canActivate: [AuthResolveGuard]
      },
      {
        path: 'userProfiles/:id',
        component: TreasuryComponent,
      },
      {
        path: 'userProfiles/:id/setup/1',
        component: Setup1Component,
      },
      {
        path: 'userProfiles/:id/setup/2',
        component: Setup2Component,
      },
      {
        path: 'userProfiles/:id/setup/3',
        component: Setup3Component,
      },
      {
        path: 'userProfiles/:id/setup/4',
        component: Setup4Component,
      },
      {
        path: 'admin-console',
        loadChildren: () => import('../creatics/admin-console/admin-console.module').then(m => m.AdminConsoleModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'verify/:id',
        component: VerificationURLComponent,
      },
      {
        path: 'emailVerify/:id',
        component: SignUpVerificationURLComponent,
      },
      {
        path: 'myTreasures',
        component: TreasuryComponent,
      },
      {
        path: 'my-inbox',
        component: MyInboxComponent
      },
      {
        path: 'my-account',
        loadChildren: () => import('./my-account/my-account.module').then(m => m.MyAccountModule)
      },
      {
        path: 'team',
        component: TeamComponent
      },
      {
        path: 'badges-awards',
        component: BadgesAwardsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'charge/products/:badgeId',
        component: PaymentReceiptComponent,
      },
      {
        path: 'createyourdreams',
        component: CreateYourDreamsComponent
      },
      {
        path: 'meet-creatics',
        component: MeetTheCreaticsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'pricing-and-plans',
        component: PricingAndAccessComponent,
      },
      {
        path: 'pricing-and-access/payment-receipt/:pricingAccessId',
        component: PricingAccessPaymentReceiptComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'termsofuse',
        component: TermsComponent
      },
      {
        path: 'privacy',
        component: PrivacyComponent
      },
      {
        path: 'prizes-and-perks',
        component: PrizesAndPerksComponent,
      }
    ]
  },
  {
    path: 'symposiums',
    loadChildren: () => import('../cinejoy/symposiums/symposiums.module').then(m => m.SymposiumsModule),
  },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreaticsRoutingModule { }
